<h1 mat-dialog-title>Pobieranie danych użytkownika</h1>
<ng-container *ngIf="!exportingData; else exportingDataTemplate">
  <ng-container *ngIf="!error; else errorTemplate">
    <mat-dialog-content>
      <p>Ta operacja może zająć kilka minut.</p>
      <p>Czy chcesz kontynuować?</p>
    </mat-dialog-content>
  </ng-container>
  <mat-dialog-actions class="dialog-actions">
    <button mat-button color="warn" [matDialogClose]="false">anuluj</button>
    <button mat-raised-button cdkFocusInitial color="primary" (click)="onFetchCustomerDataClick()">{{error ? 'spróbuj ponownie' : 'kontynuuj'}}</button>
  </mat-dialog-actions>
</ng-container>

<ng-template #exportingDataTemplate>
  <mat-dialog-content>
    <p>Trwa przygotowywanie danych do pobrania.</p>
    <p>Prosimy o cierpliwość, operacja może zająć kilka minut...</p>
    <div class="export-spinner">
      <mat-spinner></mat-spinner>
    </div>
  </mat-dialog-content>
</ng-template>

<ng-template #errorTemplate>
  <mat-dialog-content>
    <p>Przepraszamy, podczas eksportu danych wystąpił błąd.</p>
    <p>Czy chcesz spróbować ponownie?</p>
  </mat-dialog-content>
</ng-template>

